import { render, staticRenderFns } from "./MainJuez.vue?vue&type=template&id=2bf00fcf"
import script from "./MainJuez.vue?vue&type=script&lang=js"
export * from "./MainJuez.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports